import styled from 'styled-components'
import { colorTheme } from '../../../../style/theme/colorTheme'
import { theme } from '../../../../style/theme'

export const ScrollTopButtonWrap = styled.button`
	font-size: 1rem;
	position: fixed;
	display: none;
	width: 3.75em;
	height: 3.75em;
	border-radius: 50%;
	background: ${colorTheme.scrollButton.background};
	box-shadow: 0px 0px 10px 0px ${colorTheme.scrollButton.shadow};
	cursor: pointer;
	bottom: 4em;
	right: 2%;
	z-index: 2;

	&.lf-visible {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 0.25em;
	}

	> svg {
		width: 0.81em;
		height: 0.63em;
		fill: ${colorTheme.scrollButton.icon};
		flex-shrink: 0;
	}

	@media screen and (max-width: ${theme.point1280}) {
		right: 1.5%;
	}

	@media screen and (max-width: ${theme.point1024}) {
		right: 1.87em;
		bottom: 2.8em;
	}

	@media screen and (max-width: ${theme.point820}) {
		right: 1.43em;
		bottom: 2.86em;
	}

	@media screen and (max-width: ${theme.point720}) {
		right: 1.25em;
		bottom: 2.5em;
	}
`
ScrollTopButtonWrap.displayName = 'ScrollTopButtonWrap'

export const ScrollTopButtonText = styled.div`
	color: ${colorTheme.scrollButton.title};
	text-align: center;
	font-family: ${theme.fontRobotoBold};
	font-size: 0.75em;
	font-weight: 700;
	line-height: 0.92em;
	text-transform: uppercase;
`
ScrollTopButtonText.displayName = 'ScrollTopButtonText'
